<div nz-row class="login-box" nzType="flex" nzJustify="center">
  <nz-card [nzBordered]="true" nzTitle="" class="form-first-card">
    <h1 class="text">{{ "app.forgotpassword.title" | translate }}</h1>
    <p class="mt-lg mob-mt-lg mb-lg mob-mb-lg">
      {{ "app.forgotpassword.text" | translate }}
    </p>
    <form nz-form [formGroup]="validateForm" (ngSubmit)="submitForm()">
      <nz-form-item>
        <nz-form-control
          [nzErrorTip]="'app.signup.username.required' | translate"
        >
          <nz-input-group [nzPrefix]="prefixUser">
            <input
              type="text"
              nz-input
              formControlName="userName"
              placeholder="{{ 'app.label.username' | translate }}"
              [nzSize]="'large'"
            />
          </nz-input-group>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-control>
          <button
            class="mb-lg"
            nz-button
            [nzSize]="'large'"
            [nzType]="'primary'"
            [nzBlock]="true"
            [nzLoading]="loading"
            (click)="forgotPassword()"
          >
            {{ "app.send-request" | translate }}
          </button>
          <a
            *ngIf="!isUserAdmin"
            id="signup"
            class="float-right mt-md mob-mt-md"
            style="width: 49%"
            nz-button
            (click)="signup()"
            >{{ "app.label.signup" | translate }}</a
          >
          <a
            *ngIf="!isUserAdmin"
            id="signin"
            class="float-left mt-md mob-mt-md"
            style="width: 50%"
            nz-button
            (click)="signin()"
            >{{ "app.label.signin" | translate }}</a
          >
          <a
            *ngIf="isUserAdmin"
            id="signin"
            class="float-left mt-md mob-mt-md"
            style="width: 100%"
            nz-button
            (click)="signin()"
            >{{ "app.label.signin" | translate }}</a
          >
        </nz-form-control>
      </nz-form-item>
    </form>
    <ng-template #prefixUser><i nz-icon nzType="user"></i></ng-template>
  </nz-card>
</div>
